import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import sampleAppManifests from "./sample-app-manifests.json"; // This file is generated by bin/gen-sample-app-manifests-json.ts at build time.

export const URL_SEARCH_KEY_SAMPLE_APP_ID = "sampleAppId";

const InvalidSampleAppIdSymbol = Symbol("InvalidSampleAppId");

export function useSampleAppId(): string | null {
  const [searchParams, setSearchParams] = useSearchParams();
  const sampleAppId: string | null | typeof InvalidSampleAppIdSymbol =
    useMemo(() => {
      const sampleAppIdFromUrl = searchParams.get(URL_SEARCH_KEY_SAMPLE_APP_ID);

      if (sampleAppIdFromUrl == null) {
        return null;
      }
      if (sampleAppManifests.find((m) => m.id === sampleAppIdFromUrl)) {
        return sampleAppIdFromUrl;
      }
      return InvalidSampleAppIdSymbol;
    }, [searchParams]);

  if (sampleAppId == null) {
    return null;
  }

  if (sampleAppId === InvalidSampleAppIdSymbol) {
    setSearchParams((curParams) => {
      const newParams = new URLSearchParams();
      curParams.forEach((value, key) => {
        if (key === URL_SEARCH_KEY_SAMPLE_APP_ID) {
          return;
        }
        newParams.append(key, value);
      });
      return newParams;
    });
    return null;
  }

  return sampleAppId;
}

export const URL_SEARCH_KEY_EMBED_MODE = "embed";

export function useEmbedMode() {
  const [searchParams] = useSearchParams();

  const embedMode = useMemo(() => {
    const embedModeFromUrl = searchParams.get(URL_SEARCH_KEY_EMBED_MODE);

    if (embedModeFromUrl == null) {
      return false;
    }
    return embedModeFromUrl === "true";
  }, [searchParams]);

  return embedMode;
}
